import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { Menu } from 'lucide-react';
import LogoutButton from './LogoutButton';
import NotificationBell from './notifications/NotificationBell';
import { useBrandName } from '../hooks/useBrandName';

interface NavbarProps {
  onMobileSidebarToggle?: () => void;
}

const Navbar: React.FC<NavbarProps> = ({ onMobileSidebarToggle }) => {
  const { user, isAuthenticated } = useAuth0();
  const brandName = useBrandName();

  if (!isAuthenticated) return null;

  return (
    <nav className="bg-white/80 backdrop-blur-xl border-b border-gray-200/50 sticky top-0 z-50 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center space-x-3">
            {/* Mobile Menu Button */}
            <button
              onClick={onMobileSidebarToggle}
              className="lg:hidden p-2 rounded-lg hover:bg-gray-100 transition-colors"
            >
              <Menu className="w-5 h-5 text-gray-600" />
            </button>
            
            <div 
              className="flex items-center space-x-3 cursor-pointer hover:opacity-80 transition-opacity"
              onClick={() => window.location.reload()}
            >
              <img
                src="/logo.jpg"
                alt={brandName}
                className="w-10 h-10 rounded-lg object-cover shadow-md"
              />
              <div>
                <h1 className="text-xl font-bold text-gray-900">
                  {brandName}
                </h1>
                <p className="text-xs text-gray-500 hidden sm:block">Itinerary Management</p>
              </div>
            </div>
          </div>
          
          <div className="flex items-center space-x-4">
            <NotificationBell />
            <div className="hidden md:flex items-center space-x-3 px-4 py-2 bg-gray-50 rounded-xl">
              {user?.picture && (
                <img 
                  src={user.picture} 
                  alt={user.name} 
                  className="w-8 h-8 rounded-full ring-2 ring-blue-200"
                />
              )}
              <div className="text-left">
                <p className="text-sm font-semibold text-gray-900">{user?.name}</p>
                <p className="text-xs text-gray-500">{user?.email}</p>
              </div>
            </div>
            <LogoutButton />
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
